import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import seo from "../seo/pages.json";

// Keeps <title>, description, canonical and Open Graph tags in sync with the
// current route on client side navigation. The initial values are written
// into each route's static HTML at build time by scripts/prerender-seo.js.
const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!href) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const findPage = (pathname) => {
  const normalized = pathname.replace(/\/+$/, "") || "/";
  return seo.pages.find((p) => p.path === normalized) || seo.notFound;
};

const SeoHead = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const page = findPage(pathname);
    const url = page.path ? `${seo.siteUrl}${page.path === "/" ? "/" : page.path}` : null;
    document.title = page.title;
    setMeta("name", "description", page.description);
    setMeta("property", "og:title", page.title);
    setMeta("property", "og:description", page.description);
    if (url) setMeta("property", "og:url", url);
    setCanonical(url);
  }, [pathname]);

  return null;
};

export default SeoHead;
